//* ============================ INFOS ============================
export type CommissionTemplateInfo = {
  id: string
  name: string
  description: string
  active: boolean
  feeTypes: FeeType[]
  commissionBasedOn: CommissionBasedOn
  baseCommissionPercent: number
  tierType: TierType
  tierFixedDate: string | null
  commissionTiers?: CommissionTemplateTierInfo[]
  firstFundingBonusEnabled?: boolean
  firstFundingBonusAmount?: number
  thresholdBonuses?: CommissionTemplateThresholdBonusInfo[]
  hasBonuses?: boolean
}

export type CommissionTemplateTierInfo = {
  id: string
  endDay: number
  tierCommissionPercent: number
}

export type CommissionTemplateThresholdBonusInfo = {
  id: string
  thresholdAmount: number
  bonusAmount: number
}

//* ============================ RESPONSES ========================
export type CommissionTemplateSingletonResponse = {
  commissionTemplate: CommissionTemplateInfo
}

export type CommissionTemplateListResponse = {
  commissionTemplates: CommissionTemplateInfo[]
}

export type FeeTypeListResponse = {
  feeTypes: string[]
}

//* ============================ REQUESTS =========================
export type CreateCommissionTemplateRequest = {
  name: string
  description?: string
  active?: boolean
  feeTypes: string[]
  commissionBasedOn?: CommissionBasedOn
  baseCommissionPercent: number
  tierType: string
  tierFixedDate?: string | null
  commissionTiers?: CommissionTemplateTierRequest[]
  firstFundingBonusEnabled?: boolean
  firstFundingBonusAmount?: number
  thresholdBonuses?: CommissionTemplateThresholdBonusRequest[]
}

export type UpdateCommissionTemplateRequest = {
  name?: string
  description?: string
  active?: boolean
  feeTypes?: string[]
  commissionBasedOn?: CommissionBasedOn
  baseCommissionPercent?: number | undefined | null
  tierType?: string
  tierFixedDate?: string | null
  commissionTiers?: CommissionTemplateTierRequest[] | null
  firstFundingBonusEnabled?: boolean
  firstFundingBonusAmount?: number | null
  thresholdBonuses?: CommissionTemplateThresholdBonusRequest[] | null
}

export type CommissionTemplateTierRequest = {
  endDay: number
  tierCommissionPercent: number | string
}

export type CommissionTemplateThresholdBonusRequest = {
  thresholdAmount: number | string
  bonusAmount: number | string
}

//* ============================ PARAMS ===========================
export type GetCommissionTemplateListQueryParams = {
  q?: string
  name?: string
  feeType?: string
  sort?: string
  baseCommissionPercentMin?: number
  baseCommissionPercentMax?: number
  tierFixedDateLocaleStartAt?: Date
  tierFixedDateLocaleEndAt?: Date
  tierType?: string
}

//* ============================ ENUMS ============================
export enum FeeType {
  PURCHASE_FEE = 'PURCHASE_FEE',
  COLLECTION_FEE = 'COLLECTION_FEE',
  PORTFOLIO_INTEREST_FEE = 'PORTFOLIO_INTEREST_FEE',
  ADDITIONAL_FEE = 'ADDITIONAL_FEE',
  NEGATIVE_INTEREST_FEE = 'NEGATIVE_INTEREST_FEE',
  PAYMENT_FEES = 'PAYMENT_FEES',
  QP_FEE = 'QP_FEE',
  COST_OF_FUNDS = 'COST_OF_FUNDS',
}

export enum TierType {
  FIRST_FUNDING = 'FIRST_FUNDING',
  FIXED_DATE = 'FIXED_DATE',
}

export enum CommissionBasedOn {
  FUNDED_INVOICES = 'FUNDED_INVOICES',
  CLOSED_INVOICES = 'CLOSED_INVOICES',
}
